/*eslint-disable*/
export default ssgg21_navbar => {
  let $ssgg21_navbar = $(ssgg21_navbar)
  if (document.querySelector('body').classList.contains('template-article')) {
    let article_href = window.location.pathname.split('magazine/')[1]
    $ssgg21_navbar.find(`.js-nav-category[data-magazine-href=${article_href}]`).addClass('selected')
    $ssgg21_navbar.find('.js-nav-category').each((idxr, chapter) => $(chapter).click((e) => window.location.href = ($(e.target).data('magazine-href'))))
  }
}


// WEBPACK FOOTER //
// ./src/scripts/components/spring-summer-gift-guide-2021-nav-selection.js